import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { LoaderModule } from '@core/loader/loader.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { ExogenousLinesComponent } from './exogenous-lines.component';

@NgModule({
  imports: [CommonModule, CoreModule, SharedModule, SpreadSheetsModule, MatProgressSpinnerModule, LoaderModule],
  declarations: [ExogenousLinesComponent]
})
export class ExogenousLinesModule {}
